import ExpansionTextItem from './ExpansionTextItem';
import React, { useState, useContext } from 'react';
import NodeWrapper from './NodeWrapper';

import useRenderedBoundingBox from './useRenderedBoundingBox';

const defaultColor = "white";


export default function Scalebar({
  ref,
  lineStyle, 
  style, 
  position, 
  nodeId, 
  node, 
  nodes, 
  onEvent, 
  regions, 
  selected,
  parentBox,
  evaluate
}){

  


  let [ bounds, boundsListener ] = useRenderedBoundingBox();

  
  const onSomeClick = e => {


    e.preventDefault();
    e.stopPropagation();

    onEvent({
      event:e,
      type:e.type,
      itemType:"expansionNode",
      node,
      nodeId,
    })
  }

  let textStyle = {...style};

  let borderProps = ["borderTop","borderBottom","borderLeft","borderRight"];

  let borderStyles = {
    border:'2px solid blue',
  };



  borderProps.forEach(prop => {
    let borderStyleInfo = textStyle[prop];

    let { borderThickness=1, borderColor=defaultColor } = textStyle || {};
    
    if( !evaluate ){
      borderColor = defaultColor;
    }

    if( borderStyleInfo ){
      borderStyles[prop] = 
        `${borderThickness}px solid ${borderColor}`;
    }
  })


  let { textPosition, thickness } = node;
  let left = textPosition === "left";
  let right = textPosition === "right";
  let top = textPosition === "top";
  let bottom = textPosition === "bottom";


  let { value="?", units="µm" } = node?.computed || {};


  let finalValue = !isNaN(value) ? value.toFixed(4) : value;
  if( (value+"").length > 5 ){
    value = (value+"").slice(0,5)
  }

  let label = value + " " + units;


  let textComp = <div nodeid={nodeId}  style={{
    textAlign:'center',
    textWrap:'none',
    whiteSpace:'nowrap',
    //color:style?.color,
  }}><span item={"text"}>{label || "ERROR" }</span></div>;


  let computedWidthProp = (
    node.computed?.widthAsRegionProportion
  )


  
  const templateWidthProportion = 0.25;
  let widthAsRegionProportion = computedWidthProp || templateWidthProportion;

  let width = (widthAsRegionProportion * parentBox.width);

  const color = style?.color || "white";

  let structure = (
    <div style={{
      color, 
      position:'relative',

      //border:'3px solid transparent',
      }} class="sg-row v-center">
      {left && textComp} 
      <div style={{ }}
        class="sg-col h-center full-width">
        {top && textComp}
        {width && <div  class="sg-row full-width h-center">
            <div
              item="scalebar-line"
          style={{
          width, 
          height:thickness, 
          background:color,
        }}/>
          

          {SPACE_FOR_EAISER_HOVER}

        </div>
        }
        {bottom && textComp}
      </div>
      {right && textComp}
    </div>
  )


  return (
    <>
      <div 
        component="scalebar"
        item="content"
        ref={boundsListener}
        nodeId={nodeId}
        onContextMenu={onSomeClick}
        //onClick={onSomeClick}
        //item={"content"}

        style={{
          pointerEvents:'auto',
          //minWidth:40,//node?.computed?.width|| (40 + '%'),
          //border:'2px solid blue',
          //color:'blue',
          //fontWeight:'bold',
          ...textStyle,
          position:'relative',
          //zIndex:10000,

        }}>
        

        {structure}

      </div>
    </>
  )
}

const SPACE_FOR_EAISER_HOVER = (<div style={{position:'absolute',
  top:-3,
  height:'calc(100% + 6px)',
  width:'100%',
}}/>)

